import { useState, useEffect } from "react";
import useAuthStore from "../../store/authStore";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/apiClient";

const ResetPassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [mustChangePassword, setMustChangePassword] = useState(false);

  const navigate = useNavigate();
  const userRole = useAuthStore.getState().role;
  const employeeId = useAuthStore.getState().employeeId;
  const token = useAuthStore.getState().token;

  useEffect(() => {
    const mustChange = useAuthStore.getState().mustChangePassword;
    setMustChangePassword(mustChange);
    if (!token && !mustChange) navigate("/login");
  }, [navigate, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!oldPassword) return setError("Old password is required.");
    if (!newPassword || !confirmPassword) return setError("New password and confirmation are required.");
    if (newPassword !== confirmPassword) return setError("Passwords do not match.");

    try {
      const payload = mustChangePassword
        ? { employee_id: employeeId, old_password: oldPassword, new_password: newPassword }
        : { old_password: oldPassword, new_password: newPassword };

      const headers = !mustChangePassword && token
        ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
        : { "Content-Type": "application/json" };

      const response = await apiClient.post("/accounts/api/reset-password/", payload, { headers });
      setSuccess(response.data.message);
      useAuthStore.getState().setAuth({ mustChangePassword: false });

      setTimeout(() => {
        if (userRole === "ADMIN") navigate("/admin/dashboard", { replace: true });
        else if (userRole === "MANAGER") navigate("/manager/dashboard", { replace: true });
        else if (userRole === "EMPLOYEE") navigate("/employee/dashboard", { replace: true });
        else navigate("/login", { replace: true });
      }, 1500);
    } catch (err) {
      const message = err.response?.data?.error || "Something went wrong.";
      setError(Array.isArray(message) ? message.join(" ") : message);
    }
  };

  const handleBack = () => {
    if (userRole === "ADMIN") navigate("/admin/dashboard", { replace: true });
    else if (userRole === "MANAGER") navigate("/manager/dashboard", { replace: true });
    else if (userRole === "EMPLOYEE") navigate("/employee/dashboard", { replace: true });
    else navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-indigo-500 to-blue-500 px-4 py-8">
      <div className="w-full max-w-lg bg-white/10 backdrop-blur-xl rounded-3xl border border-white/20 p-6 sm:p-8 shadow-lg">

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6 text-center">
          Change Password
        </h2>

        {error && <div className="text-red-400   text-center mb-4 text-sm">{error}</div>}
        {success && <div className="text-green-400 text-center mb-4 text-sm">{success}</div>}

        <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
          <div>
            <label className="block text-white/80 text-sm mb-2">Old Password</label>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Enter current or temporary password"
              className="w-full p-3 sm:p-4 rounded-xl bg-white/5 text-white placeholder-white/60
                border border-white/30 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            />
          </div>

          <div>
            <label className="block text-white/80 text-sm mb-2">New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              className="w-full p-3 sm:p-4 rounded-xl bg-white/5 text-white placeholder-white/60
                border border-white/30 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            />
          </div>

          <div>
            <label className="block text-white/80 text-sm mb-2">Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
              className="w-full p-3 sm:p-4 rounded-xl bg-white/5 text-white placeholder-white/60
                border border-white/30 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-500
              text-white font-semibold shadow-lg hover:opacity-95 active:scale-[0.98] transition-all duration-300"
          >
            Change Password
          </button>
        </form>

        <div className="text-center mt-6">
          <button
            onClick={handleBack}
            className="text-white/60 hover:text-white transition duration-300 text-sm"
          >
            ← Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
